import SmoothScroll from 'smooth-scroll'
import { $, $$ } from '../_utils'

const scroll = new SmoothScroll()

const formatTocItems = titles => {
  const convertTitleToLi = (acc, curr) => {
    const li = document.createElement('li')
    const slug = titleSlug(curr)
    li.innerHTML = `<a href="#${slug}">${curr}</a>\n`
    li.classList.add('article-single__article-link')
    li.addEventListener('click', el => {
      el.preventDefault()
      const link = $(`#${slug}`)
      scroll.animateScroll(link)
    })
    return [...acc, li]
  }
  return titles.reduce(convertTitleToLi, [])
}

const replacePolishChars = titleString => {
  const replacements = [
    ['ą', 'ć', 'ę', 'ł', 'ó', 'ż', 'ź'],
    ['a', 'c', 'e', 'l', 'o', 'z', 'z'],
  ]
  return titleString
    .split('')
    .map(letter => {
      const indexOfPlLetter = replacements[0].indexOf(letter)
      if (indexOfPlLetter !== -1) {
        return replacements[1][indexOfPlLetter]
      }
      return letter
    })
    .join('')
}
const titleSlug = titleString =>
  replacePolishChars(titleString.toLocaleLowerCase('pl'))
    .split(/\s|[^a-z]/gm)
    .filter(elem => elem)
    .join('-')

window.addEventListener('DOMContentLoaded', () => {
  const $$articleChapters = $$('h2').filter(elem => elem !== document.getElementById('toc-header'))
  const $tocWrapper = $('#toc-header')
  const $ul = $('.article-single__linkset')
  const formattedTitles = []

  for (const chapter of $$articleChapters) {
    const sectionTitle = chapter.innerText
    formattedTitles.push(sectionTitle)
    chapter.setAttribute('id', titleSlug(sectionTitle))
  }

  // If the TOC element is present and if there are section titles...
  if ($ul && formattedTitles.length > 0) {
    formatTocItems(formattedTitles).forEach(title => $ul.appendChild(title))
  } else {
    $tocWrapper ? $tocWrapper?.classList.add('hidden') : null
  }
})
